import { schema } from 'normalizr';
import { MentoringProgramActionItem } from '../models/mentoring-program-action-items';

export const MentorshipProgramActionItemSchema = new schema.Entity<MentoringProgramActionItem>('mentorshipProgramActionItems');

export const MentorshipProgramActionItemsSchema = new schema.Array(MentorshipProgramActionItemSchema);
